import {AxiosServer, AxiosEsb,ArrRemoveSubItem} from '../../utils';
import {message} from 'antd';

const APP = 'app/set';

const app_SET = (text) => {		
	return{
			type:APP,
			payload:text
		} 
}

const GETROLEAUTH =(value)=>(dispatch,getState)=>{		
		let Axios = AxiosServer();

		return Axios.post('/menuAuth/findAll',value).then((res)=>{				
			if (res.data.status == true && res.data.count >0 ){	
				//如果成功，将res.data.data中的menu解构出来，取checkedKeys赋值。
				let resdata= res.data.data[0];	
				const {checkedKeys,halfCheckedKeys} =resdata.menu;
				if (!checkedKeys){					
					return '无权限'
				}
				let loginUserRoleAuth =checkedKeys.concat(halfCheckedKeys);
							
				dispatch({type: APP, payload: {loginUserRoleAuth:loginUserRoleAuth,dataLoading: false}}); 					
				return '获取成功'
			}else{				
				dispatch({type: APP, payload: {dataLoading: false}}); 
				return '无权限'
			}
			
		}).catch((err)=>{
			message.error('登陆过期或网络异常: ' + err,10);
			dispatch({type: APP, payload: {dataLoading: false}}); 
			return '获取错误'
			console.log('err:',err);
		});	
		
	};


export {APP,app_SET,GETROLEAUTH};